export const DATE_TEMPLATE = "dd.MM.yyyy";
export const DATE_TIME_TEMPLATE = "dd.MM.yyyy kk.mm";
